import Vue from "vue";
import App from "./pages/Login.vue";
import BaseFieldsPlugin from "./components/Fields/Base";
import "./core/api-setup";
import VeeValidate from "vee-validate";

Vue.use(BaseFieldsPlugin);
Vue.use(VeeValidate, {
  errorBagName: "vErrors",
  inject: false
});

const Page = Vue.component("app", App);
new Page({ el: "#app" });
